export enum TicketSaleStatusEnum {
  ON_SALE = "ON_SALE",
  SOLD_OUT = "SOLD_OUT",
  UPCOMING_SALE = "UPCOMING_SALE",
  PAST_SALE = "PAST_SALE"
}
